import { Injectable } from '@angular/core';
import { CommonService } from 'src/app/shared/utils/common.service';
import { UtilsService } from 'src/app/shared/utils/utils.service';

@Injectable({
  providedIn: 'root'
})
export class UbitsService {

  urlNomina: string;
  
  constructor(private commom: CommonService,
    private utilServices: UtilsService) {
    this.urlNomina = this.utilServices.getNomina();
  }

  updateUbits(area: string, localidad: string, cedula: string){
    let url = this.urlNomina + 'ubits/update/' + area + '/' + localidad + '/' + cedula;  
    return this.commom.peticionPutConHeader(this.urlNomina + 'ubits/update/' + area + '/' + localidad + '/' + cedula, null);
  }

  updateUbitsCedula(cedula: string){
    let url = this.urlNomina + 'ubits/update/'+ cedula;
    return this.commom.peticionPutConHeader(url, null);
  }

  createUserUbits(area: string, localidad: string, cedula: string){
    return this.commom.peticionPostConHeader(this.urlNomina + 'ubits/create/' + area + '/' + localidad + '/' + cedula, null);
  }


  createUserDAUbits(area: string, localidad: string, cedula: string){
    return this.commom.peticionPostConHeader(this.urlNomina + 'ubits/create/' + area + '/' + localidad + '/' + cedula, null);
  }

}
